import { render, staticRenderFns } from "./InteligenciaTerritorialImovel.vue?vue&type=template&id=483747ae&scoped=true&lang=pug"
import script from "./InteligenciaTerritorialImovel.vue?vue&type=script&lang=js"
export * from "./InteligenciaTerritorialImovel.vue?vue&type=script&lang=js"
import style0 from "./InteligenciaTerritorialImovel.vue?vue&type=style&index=0&id=483747ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483747ae",
  null
  
)

export default component.exports